module.exports = __webpack_public_path__ + "media/faucet_lower.845eb3aa.mp4";